import { ChangeEvent, useCallback } from 'react'
import { produce } from 'immer'
import { useFormikContext } from 'formik'
import { AddServiceLocationFormModel } from '../formModel'
import { FormFieldsProps } from '../typings'

export function useForm(params: FormFieldsProps) {
  const { locationTypes, divisions, branches } = params

  const {
    isSubmitting,
    submitForm,
    setValues,
    values: { firstName, lastName, company, emailAddresses, phoneNumber },
  } = useFormikContext<AddServiceLocationFormModel>()

  const onChangeBranch = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const selection = branches.find((x) => x.value === event.target.value)

      if (!!selection) {
        setValues((current) =>
          produce(current, (draft) => {
            draft.branchId = selection.value
            draft.branch = selection.label
          }),
        )
      }
    },
    [branches, setValues],
  )

  const onChangeLocationType = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const selection = locationTypes.find(
        (x) => x.value === event.target.value,
      )

      if (!!selection) {
        setValues((current) =>
          produce(current, (draft) => {
            draft.locationTypeId = selection.value
            draft.locationType = selection.label
          }),
        )
      }
    },
    [locationTypes, setValues],
  )

  const onChangeDivision = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const selection = divisions.find((x) => x.value === event.target.value)

      if (!!selection) {
        setValues((current) =>
          produce(current, (draft) => {
            draft.divisionId = selection.value
            draft.division = selection.label
          }),
        )
      }
    },
    [divisions, setValues],
  )

  return {
    isSubmitting,
    submitForm,
    onChangeBranch,
    onChangeLocationType,
    onChangeDivision,
    nameRequired: company === '' && lastName === '' && firstName === '',
    emailRequired: phoneNumber === '',
    phoneRequired: !emailAddresses.find((x) => x.emailAddress !== ''),
  }
}
